module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-11.02668bce.png";